import { render, staticRenderFns } from "./AddProductPackage.vue?vue&type=template&id=704786f0&scoped=true"
import script from "./AddProductPackage.vue?vue&type=script&lang=js"
export * from "./AddProductPackage.vue?vue&type=script&lang=js"
import style0 from "./AddProductPackage.vue?vue&type=style&index=0&id=704786f0&prod&scoped=true&lang=css"
import style1 from "../../../assets/styles/multiselect.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704786f0",
  null
  
)

export default component.exports